import { useGetSignedAgreements } from "@src/appV2/Agreements/api/useGetSignedAgreements";
import { AgreementKind } from "@src/appV2/Agreements/types";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

interface UseHasSignedContractorAgreementResult {
  hasSigned: boolean;
  isLoading: boolean;
}

export function useHasSignedContractorAgreement(): UseHasSignedContractorAgreementResult {
  const worker = useDefinedWorker();

  const { data, isLoading, isSuccess } = useGetSignedAgreements({
    workerId: worker.userId,
    kind: [AgreementKind.INDEPENDENT_CONTRACTOR],
  });

  const hasSigned = isSuccess && (data?.data?.length ?? 0) > 0;

  return { hasSigned, isLoading };
}
